import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ZTransformProperties = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Properties of Z-Transform"
    videos={[
      "https://www.youtube.com/embed/7-zAtsDhfxw",
      "https://www.youtube.com/embed/qXvmv4FJ2I8",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default ZTransformProperties;
